// extracted by mini-css-extract-plugin
export var sliderImg = "swiperScreen-module--sliderImg--tItb-";
export var swiperImg = "swiperScreen-module--swiperImg--muRR9";